module.exports = __webpack_public_path__ + "img/looter_bg.e64d6279.png";